import { type OrchestratedListingDetails } from '@b-stock/fe-core/bstock-next/queries'

import useAccountId from '@/buyer-portal/helpers/useAccountId'

export const useIsSellerUserOwner = (listing: OrchestratedListingDetails) => {
  const accountId = useAccountId()

  const isSellerUserOwner = listing.lot.accountId === accountId
  return isSellerUserOwner
}
